// extracted by mini-css-extract-plugin
export var actionButton = "_kx-0";
export var actionMenuContainer = "_kx-i";
export var bubble = "_kx-2";
export var bubbleActionMenu = "_kx-j";
export var bubbleContext = "_kx-6";
export var bubbleItems = "_kx-7";
export var customer = "_kx-3";
export var divider = "_kx-8";
export var fileList = "_kx-9";
export var hiddenComment = "_kx-o";
export var infoAbove = "_kx-a";
export var internal = "_kx-4";
export var lightActionButton = "_kx-1";
export var link = "_kx-b";
export var merchant = "_kx-5";
export var message = "_kx-c";
export var profilePicture = "_kx-e";
export var quillToolbarContainer = "_kx-f";
export var senderDate = "_kx-g";
export var senderDateCustomer = "_kx-h";
export var senderName = "_kx-d";
export var time = "_kx-k";
export var uploadedImage = "_kx-l";
export var username = "_kx-m";
export var xsmall = "_kx-n";